import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const founders = [
  {
    image: '/images/profile_Bojan_avatar.png',
    name: 'Bojan Teshin',
    role: 'GTM & Growth',
    bio: '15+ years across SaaS, subscription, media and technology, working across acquisition, conversion, retention and recurring-revenue growth.',
  },
  {
    image: '/images/profile_Nenad_avatar.png',
    name: 'Nenad Stojkovic, PhD',
    role: 'Product & Software Architecture',
    bio: '13+ years in software engineering and architecture, including complex customer-data platforms and software systems.',
  },
  {
    image: '/images/profile_Daniel_avatar.png',
    name: 'Daniel Kupčo',
    role: 'Engineering & Integrations',
    bio: '10+ years experience as a Software engineer focused on system integrations, .NET, cloud infrastructure and production systems.',
  },
];

export default function TeamSection() {
  return (
    <section className="py-24 px-6 border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-5">
            Built by people who know the problem from both sides.
          </h2>
          <p className="landing-prose">
            Commercial experience to understand the problem. Technical depth to build around it.
          </p>
        </LandingReveal>

        <div className="grid md:grid-cols-3 gap-6">
          {founders.map((founder, index) => (
            <LandingReveal
              key={founder.name}
              delayClass={index === 0 ? 'landing-delay-1' : index === 1 ? 'landing-delay-2' : 'landing-delay-3'}
            >
              <article className="landing-card p-7 flex flex-col h-full">
                <img
                  src={founder.image}
                  alt={founder.name}
                  className="landing-founder-avatar mb-5 h-28 w-28 rounded-full object-cover block mx-auto"
                />
                <h3 className="text-xl font-bold text-primary font-secondary mb-1 text-center">{founder.name}</h3>
                <p className="text-accent text-sm font-semibold mb-4 text-center">{founder.role}</p>
                <p className="text-secondary leading-relaxed text-[0.975rem]">{founder.bio}</p>
              </article>
            </LandingReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
